// import React, { useState, useRef, useEffect } from 'react';
// import {
//    Box,
//    Button,
//    Checkbox,
//    Flex,
//    Grid,
//    Input,
//    Modal,
//    ModalBody,
//    ModalCloseButton,
//    ModalContent,
//    ModalHeader,
//    ModalOverlay,
//    Table,
//    TableContainer,
//    Tbody,
//    Td,
//    Th,
//    Thead,
//    Tr,
//    useColorModeValue,
//    Switch,
//    ModalFooter,
// } from '@chakra-ui/react';
// import { removeDuplicates, filterStocks } from 'utils/util';

// const SerialNumberModal = ({ isOpen, onClose, stockList, selectedStocks, handleSelectStock, onCloseComplete }) => {
//    const [searchQuery, setSearchQuery] = useState('');
//    const searchRef = useRef(null);

//    useEffect(() => {
//       if (isOpen && searchRef.current) {
//          searchRef.current.focus();
//       }
//    }, [isOpen]);

//    return (
//       <Modal isOpen={isOpen} onClose={onClose} isCentered initialFocusRef={searchRef} onCloseComplete={onCloseComplete}>
//          <ModalOverlay />
//          <ModalContent
//             bg={useColorModeValue('white', '#2d3748')}
//             color={useColorModeValue('gray.800', 'white')}
//             borderRadius="20px"
//             p={5}
//             boxShadow="lg"
//             sx={{ maxW: '100rem' }}>
//             <ModalHeader fontSize="20px" fontWeight="600" mb={4}>
//                Add Serial Number
//             </ModalHeader>
//             <ModalCloseButton />
//             <ModalBody>
//                <Grid gap={2}>
//                   <Flex justifyContent="space-between" mb={2}>
//                      <Box w="100%"></Box>
//                      <Input
//                         ref={searchRef}
//                         placeholder="Search here..."
//                         value={searchQuery}
//                         onChange={(e) => setSearchQuery(e.target.value)}
//                      />
//                   </Flex>
//                   <TableContainer border="1px" borderColor="gray.200" borderRadius={5}>
//                      <Table variant="simple" border="1px solid #E2E8F0" size="md">
//                         <Thead bg="gray.200">
//                            <Tr borderBottom="1px solid #E2E8F0">
//                               <Th borderBottom="1px solid #E2E8F0"></Th>
//                               <Th borderBottom="1px solid #E2E8F0">Item Name</Th>
//                               <Th borderBottom="1px solid #E2E8F0">Transaction Type</Th>
//                               <Th borderBottom="1px solid #E2E8F0">Party Name</Th>
//                               <Th borderBottom="1px solid #E2E8F0">Series No 1</Th>
//                               <Th borderBottom="1px solid #E2E8F0">Series No 2</Th>
//                               <Th borderBottom="1px solid #E2E8F0">Barcode</Th>
//                               <Th borderBottom="1px solid #E2E8F0">Item Rate</Th>
//                               <Th borderBottom="1px solid #E2E8F0">Is Old</Th>
//                            </Tr>
//                         </Thead>
//                         <Tbody>
//                            {/* {filterStocks(removeDuplicates(stockList, 'serialNo'), searchQuery).map((item, index) => { */}
//                            {filterStocks(stockList, searchQuery).map((item, index) => {
//                               return (
//                                  <Tr key={index} borderBottom="1px solid #E2E8F0">
//                                     <Td borderBottom="1px solid #E2E8F0">
//                                        <Checkbox
//                                           isChecked={selectedStocks?.map((a) => a?.serialNo).includes(item?.serialNo)}
//                                           onChange={(e) => handleSelectStock(e, item)}
//                                        // disabled={id !== null}
//                                        />
//                                     </Td>
//                                     <Td borderBottom="1px solid #E2E8F0">{item?.itemName}</Td>
//                                     <Td borderBottom="1px solid #E2E8F0">{item?.latest_transaction_type}</Td>
//                                     <Td borderBottom="1px solid #E2E8F0">{item?.account}</Td>
//                                     <Td borderBottom="1px solid #E2E8F0">{item?.serialNo}</Td>
//                                     <Td borderBottom="1px solid #E2E8F0">{item?.serialNo2}</Td>
//                                     <Td borderBottom="1px solid #E2E8F0">{item?.barcode}</Td>
//                                     <Td borderBottom="1px solid #E2E8F0">{item?.itemRate}</Td>
//                                     <Td borderBottom="1px solid #E2E8F0" isNumeric>
//                                        <Switch
//                                           name="isOld"
//                                           id={`isOld-${index}`}
//                                           defaultChecked={item?.isOld}
//                                           disabled
//                                        />
//                                     </Td>
//                                  </Tr>
//                               );
//                            })}
//                         </Tbody>
//                      </Table>
//                   </TableContainer>
//                </Grid>
//             </ModalBody>
//             <ModalFooter justifyContent="flex-end" alignItems="center">
//                <Flex>
//                   <Button
//                      colorScheme="red"
//                      onClick={() => onClose()}
//                      ml={3}
//                      width="100%"
//                      _focus={{ outlineColor: 'blue.500 ' }}>
//                      Close
//                   </Button>
//                </Flex>
//             </ModalFooter>
//          </ModalContent>
//       </Modal>
//    );
// };

// export default SerialNumberModal;

import React, { useState, useRef, useEffect } from 'react';
import {
   Box,
   Button,
   Checkbox,
   Flex,
   Grid,
   Input,
   Modal,
   ModalBody,
   ModalCloseButton,
   ModalContent,
   ModalHeader,
   ModalOverlay,
   Table,
   TableContainer,
   Tbody,
   Td,
   Th,
   Thead,
   Tr,
   useColorMode,
   Switch,
   ModalFooter,
} from '@chakra-ui/react';
import { removeDuplicates, filterStocks } from 'utils/util';

const SerialNumberModal = ({ isOpen, onClose, stockList, selectedStocks, handleSelectStock, onCloseComplete }) => {
   const [searchQuery, setSearchQuery] = useState('');
   const searchRef = useRef(null);
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   useEffect(() => {
      if (isOpen && searchRef.current) {
         searchRef.current.focus();
      }
   }, [isOpen]);

   const handleClose = () => {
      setSearchQuery('');
      onClose();
   };

   return (
      <Modal isOpen={isOpen} onClose={handleClose} isCentered initialFocusRef={searchRef} onCloseComplete={onCloseComplete}>
         <ModalOverlay bg="blackAlpha.600" />
         <ModalContent
            bg={isDark ? '#1a202c' : '#ffffff'}
            borderRadius="24px"
            p={0}
            boxShadow={isDark ? '0 25px 50px -12px rgba(0, 0, 0, 0.8)' : '0 25px 50px -12px rgba(0, 0, 0, 0.25)'}
            sx={{ maxW: '100rem' }}
            border={isDark ? '1px solid #2d3748' : '1px solid #e2e8f0'}>
            <ModalHeader
               fontSize="24px"
               fontWeight="700"
               bg={
                  isDark
                     ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                     : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
               }
               color="white"
               borderTopRadius="24px"
               py={6}
               px={8}
               position="relative">
               Add Serial Number
               <ModalCloseButton
                  color="white"
                  top={6}
                  right={6}
                  _hover={{ bg: 'whiteAlpha.300' }}
                  borderRadius="full"
               />
            </ModalHeader>
            <ModalBody p={8}>
               <Grid gap={6}>
                  <Flex justifyContent="space-between" mb={2}>
                     <Input
                        ref={searchRef}
                        placeholder="🔍 Search items, serial numbers, barcodes..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        size="lg"
                        bg={isDark ? '#2d3748' : '#f7fafc'}
                        border={isDark ? '2px solid #4a5568' : '2px solid #e2e8f0'}
                        borderRadius="16px"
                        color={isDark ? 'white' : 'gray.800'}
                        _hover={{
                           border: isDark ? '2px solid #667eea' : '2px solid #667eea',
                           boxShadow: isDark
                              ? '0 0 0 3px rgba(102, 126, 234, 0.2)'
                              : '0 0 0 3px rgba(102, 126, 234, 0.1)',
                        }}
                        _focus={{
                           border: '2px solid #667eea',
                           boxShadow: isDark
                              ? '0 0 0 3px rgba(102, 126, 234, 0.3)'
                              : '0 0 0 3px rgba(102, 126, 234, 0.2)',
                           outline: 'none',
                        }}
                        fontSize="16px"
                        fontWeight="500"
                     />
                  </Flex>
                  <TableContainer
                     border={isDark ? '2px solid #4a5568' : '2px solid #e2e8f0'}
                     borderRadius="20px"
                     bg={isDark ? '#2d3748' : '#ffffff'}
                     boxShadow={isDark ? '0 4px 6px -1px rgba(0, 0, 0, 0.4)' : '0 4px 6px -1px rgba(0, 0, 0, 0.1)'}
                     maxH="500px"
                     overflowY="auto"
                     css={{
                        '&::-webkit-scrollbar': {
                           width: '12px',
                        },
                        '&::-webkit-scrollbar-track': {
                           background: isDark ? '#1a202c' : '#f1f1f1',
                           borderRadius: '10px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                           background: isDark ? '#667eea' : '#cbd5e0',
                           borderRadius: '10px',
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                           background: isDark ? '#764ba2' : '#a0aec0',
                        },
                     }}>
                     <Table variant="simple" size="md">
                        <Thead
                           bg={
                              isDark
                                 ? 'linear-gradient(135deg, #4a5568 0%, #2d3748 100%)'
                                 : 'linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)'
                           }
                           position="sticky"
                           top={0}
                           zIndex={1}>
                           <Tr>
                              <Th
                                 borderBottom={isDark ? '2px solid #667eea' : '2px solid #cbd5e0'}
                                 color={isDark ? '#e2e8f0' : '#2d3748'}
                                 fontSize="13px"
                                 fontWeight="800"
                                 letterSpacing="0.5px"
                                 py={5}
                                 textTransform="uppercase"></Th>
                              <Th
                                 borderBottom={isDark ? '2px solid #667eea' : '2px solid #cbd5e0'}
                                 color={isDark ? '#e2e8f0' : '#2d3748'}
                                 fontSize="13px"
                                 fontWeight="800"
                                 letterSpacing="0.5px"
                                 py={5}
                                 textTransform="uppercase">
                                 Item Name
                              </Th>
                              <Th
                                 borderBottom={isDark ? '2px solid #667eea' : '2px solid #cbd5e0'}
                                 color={isDark ? '#e2e8f0' : '#2d3748'}
                                 fontSize="13px"
                                 fontWeight="800"
                                 letterSpacing="0.5px"
                                 py={5}
                                 textTransform="uppercase">
                                 Transaction Type
                              </Th>
                              <Th
                                 borderBottom={isDark ? '2px solid #667eea' : '2px solid #cbd5e0'}
                                 color={isDark ? '#e2e8f0' : '#2d3748'}
                                 fontSize="13px"
                                 fontWeight="800"
                                 letterSpacing="0.5px"
                                 py={5}
                                 textTransform="uppercase">
                                 Party Name
                              </Th>
                              <Th
                                 borderBottom={isDark ? '2px solid #667eea' : '2px solid #cbd5e0'}
                                 color={isDark ? '#e2e8f0' : '#2d3748'}
                                 fontSize="13px"
                                 fontWeight="800"
                                 letterSpacing="0.5px"
                                 py={5}
                                 textTransform="uppercase">
                                 Series No 1
                              </Th>
                              <Th
                                 borderBottom={isDark ? '2px solid #667eea' : '2px solid #cbd5e0'}
                                 color={isDark ? '#e2e8f0' : '#2d3748'}
                                 fontSize="13px"
                                 fontWeight="800"
                                 letterSpacing="0.5px"
                                 py={5}
                                 textTransform="uppercase">
                                 Series No 2
                              </Th>
                              <Th
                                 borderBottom={isDark ? '2px solid #667eea' : '2px solid #cbd5e0'}
                                 color={isDark ? '#e2e8f0' : '#2d3748'}
                                 fontSize="13px"
                                 fontWeight="800"
                                 letterSpacing="0.5px"
                                 py={5}
                                 textTransform="uppercase">
                                 Barcode
                              </Th>
                              <Th
                                 borderBottom={isDark ? '2px solid #667eea' : '2px solid #cbd5e0'}
                                 color={isDark ? '#e2e8f0' : '#2d3748'}
                                 fontSize="13px"
                                 fontWeight="800"
                                 letterSpacing="0.5px"
                                 py={5}
                                 textTransform="uppercase">
                                 Item Rate
                              </Th>
                              <Th
                                 borderBottom={isDark ? '2px solid #667eea' : '2px solid #cbd5e0'}
                                 color={isDark ? '#e2e8f0' : '#2d3748'}
                                 fontSize="13px"
                                 fontWeight="800"
                                 letterSpacing="0.5px"
                                 py={5}
                                 textTransform="uppercase"
                                 isNumeric>
                                 Is Old
                              </Th>
                           </Tr>
                        </Thead>
                        <Tbody>
                           {filterStocks(stockList, searchQuery).map((item, index) => {
                              const isSelected = selectedStocks?.map((a) => a?.serialNo).includes(item?.serialNo);
                              return (
                                 <Tr
                                    key={index}
                                    bg={
                                       isSelected
                                          ? isDark
                                             ? 'rgba(102, 126, 234, 0.2)'
                                             : 'rgba(102, 126, 234, 0.1)'
                                          : isDark
                                             ? '#2d3748'
                                             : 'white'
                                    }
                                    _hover={{
                                       bg: isDark ? 'rgba(102, 126, 234, 0.15)' : 'rgba(102, 126, 234, 0.05)',
                                       // transform: 'translateX(4px)',
                                       // transition: 'all 0.2s ease-in-out',
                                    }}
                                    transition="all 0.2s ease-in-out"
                                    borderBottom={isDark ? '1px solid #4a5568' : '1px solid #e2e8f0'}>
                                    <Td borderBottom={isDark ? '1px solid #4a5568' : '1px solid #e2e8f0'} py={4}>
                                       <Checkbox
                                          isChecked={isSelected}
                                          onChange={(e) => handleSelectStock(e, item)}
                                          colorScheme="purple"
                                          size="lg"
                                          sx={{
                                             '.chakra-checkbox__control': {
                                                borderWidth: '2px',
                                                borderRadius: '8px',
                                                borderColor: isDark ? '#667eea' : '#cbd5e0',
                                                _checked: {
                                                   bg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                   borderColor: '#667eea',
                                                },
                                             },
                                          }}
                                       />
                                    </Td>
                                    <Td
                                       borderBottom={isDark ? '1px solid #4a5568' : '1px solid #e2e8f0'}
                                       color={isDark ? '#e2e8f0' : '#2d3748'}
                                       fontWeight="600"
                                       fontSize="15px"
                                       py={4}>
                                       {item?.itemName}
                                    </Td>
                                    <Td
                                       borderBottom={isDark ? '1px solid #4a5568' : '1px solid #e2e8f0'}
                                       color={isDark ? '#cbd5e0' : '#4a5568'}
                                       fontSize="14px"
                                       py={4}>
                                       {item?.latest_transaction_type}
                                    </Td>
                                    <Td
                                       borderBottom={isDark ? '1px solid #4a5568' : '1px solid #e2e8f0'}
                                       color={isDark ? '#cbd5e0' : '#4a5568'}
                                       fontSize="14px"
                                       py={4}>
                                       {item?.account}
                                    </Td>
                                    <Td
                                       borderBottom={isDark ? '1px solid #4a5568' : '1px solid #e2e8f0'}
                                       color={isDark ? '#cbd5e0' : '#4a5568'}
                                       fontFamily="mono"
                                       fontSize="14px"
                                       py={4}>
                                       {item?.serialNo}
                                    </Td>
                                    <Td
                                       borderBottom={isDark ? '1px solid #4a5568' : '1px solid #e2e8f0'}
                                       color={isDark ? '#cbd5e0' : '#4a5568'}
                                       fontFamily="mono"
                                       fontSize="14px"
                                       py={4}>
                                       {item?.serialNo2}
                                    </Td>
                                    <Td
                                       borderBottom={isDark ? '1px solid #4a5568' : '1px solid #e2e8f0'}
                                       color={isDark ? '#cbd5e0' : '#4a5568'}
                                       fontFamily="mono"
                                       fontSize="14px"
                                       py={4}>
                                       {item?.barcode}
                                    </Td>
                                    <Td
                                       borderBottom={isDark ? '1px solid #4a5568' : '1px solid #e2e8f0'}
                                       color={isDark ? '#cbd5e0' : '#4a5568'}
                                       fontWeight="600"
                                       fontSize="14px"
                                       py={4}>
                                       {item?.finalItemCost}
                                    </Td>
                                    <Td
                                       borderBottom={isDark ? '1px solid #4a5568' : '1px solid #e2e8f0'}
                                       isNumeric
                                       py={4}>
                                       <Switch
                                          name="isOld"
                                          id={`isOld-${index}`}
                                          defaultChecked={item?.isOld}
                                          disabled
                                          colorScheme="purple"
                                          size="lg"
                                       />
                                    </Td>
                                 </Tr>
                              );
                           })}
                        </Tbody>
                     </Table>
                  </TableContainer>
               </Grid>
            </ModalBody>
            <ModalFooter
               justifyContent="flex-end"
               alignItems="center"
               bg={isDark ? '#1a202c' : '#f7fafc'}
               borderBottomRadius="24px"
               py={6}
               px={8}
               borderTop={isDark ? '2px solid #4a5568' : '2px solid #e2e8f0'}>
               <Flex gap={3}>
                  <Button
                     bg={
                        isDark
                           ? 'linear-gradient(135deg, #f56565 0%, #c53030 100%)'
                           : 'linear-gradient(135deg, #fc8181 0%, #f56565 100%)'
                     }
                     color="white"
                     onClick={() => handleClose()}
                     size="lg"
                     fontWeight="700"
                     fontSize="16px"
                     px={10}
                     borderRadius="14px"
                     _hover={{
                        transform: 'translateY(-2px)',
                        boxShadow: isDark
                           ? '0 10px 20px -5px rgba(245, 101, 101, 0.4)'
                           : '0 10px 20px -5px rgba(245, 101, 101, 0.3)',
                        bg: isDark
                           ? 'linear-gradient(135deg, #f56565 0%, #c53030 100%)'
                           : 'linear-gradient(135deg, #fc8181 0%, #f56565 100%)',
                     }}
                     _active={{
                        transform: 'translateY(0)',
                     }}
                     transition="all 0.2s ease-in-out"
                     _focus={{ outline: 'none', boxShadow: '0 0 0 3px rgba(245, 101, 101, 0.3)' }}>
                     Close
                  </Button>
               </Flex>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default SerialNumberModal;
